const config = {
  builder_id: '5820becb371e2f66d898549a',
  auth_domain: '70westbuilders.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'photos[0]',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/icon-facebook.svg',
    instagram: '/images/icon-instagram.svg',
    youtube: '/images/icon-youtube.svg',
    pinterest: '/images/icon-pinterest.svg',
  },
  filters: {
    all: {},
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ptMHJlNzB5MXQ1NTN2cGdzd3VoY2x0eSJ9.hnSumYCUxocnRrJX_2sIYA',
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js